import range from 'lodash/range';

const HomepageSlideNavigation = ({
    slideCount,
    activeSlider,
    onClick,
    label,
}: {
    slideCount: number;
    activeSlider: number;
    onClick: (button: number) => void;
    label: string;
}) => {
    const navButtons = range(0, slideCount);

    return (
        <nav className="slide-container__nav">
            <ul className="slide-container__nav-list">
                {navButtons.map((button) => (
                    <li
                        key={button}
                        className={`slide-container__nav-item ${
                            button === activeSlider ? 'slide-container__nav-item--active' : ''
                        }`}
                    >
                        <a
                            href="#slide-container-weather"
                            className="slide-container__nav-link"
                            onClick={() => onClick(button)}
                        >
                            <span className="slide-container__nav-label">{label}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default HomepageSlideNavigation;
